/* SORA Member-Get-Member — referral capture (site-wide).
 *
 * The QR / link on the box card points at  https://www.soraofficial.co/?ref=SORA-XXXX
 * We stash that code and attach it to the cart as an attribute, so it rides
 * through to the order. Cart attributes survive to the order on EVERY Shopify
 * plan (no checkout field / Plus needed) and show up in the order webhook the
 * backend listens to. Attribution captured here; all validation (self-referral,
 * refunds, code exists) happens server-side — the client is never trusted.
 *
 * Canonical code format: 'SORA-' + BigInt(customerId).toString(36).toUpperCase()
 * The SAME derivation is used by the backend and the account card, so a code is
 * 1:1 with a customer id — no lookup, no collision.
 */
(function () {
  var KEY = 'sora_ref';
  var FMT = /^SORA-[A-Z0-9]{2,16}$/;
  function clean(v) { return (v || '').trim().toUpperCase(); }

  try {
    // 1. capture an incoming ?ref= and persist it (60-day window)
    var incoming = clean(new URLSearchParams(window.location.search).get('ref'));
    if (incoming && FMT.test(incoming)) {
      localStorage.setItem(KEY, incoming);
      document.cookie = KEY + '=' + incoming + ';path=/;max-age=' + (60 * 60 * 24 * 60) + ';SameSite=Lax';
    }

    // 2. if we hold a valid code, make sure it's on the cart
    var code = clean(localStorage.getItem(KEY));
    if (!code || !FMT.test(code)) return;

    // best-effort: never attribute a signed-in member to their OWN code
    // (authoritative self-referral check is server-side against the buyer)
    var me = window.__ESNC_CUSTOMER__ || {};
    if (me.id) {
      try {
        if (('SORA-' + BigInt(me.id).toString(36).toUpperCase()) === code) return;
      } catch (e) { /* BigInt unsupported → let the server decide */ }
    }

    // write once per session; the attribute then persists on the cart
    if (sessionStorage.getItem('sora_ref_synced') === code) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { referral_code: code } })
    }).then(function () {
      sessionStorage.setItem('sora_ref_synced', code);
    }).catch(function () { /* offline / cart unavailable — retry next load */ });
  } catch (e) { /* never break the page over a referral */ }
})();
